var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-flex"},[_c('span',{ref:"number"}),_vm._v(" "+_vm._s(_vm.suffix)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }